import Farm from "@/farm/Farm"

export default class Cheat {
  name: string
  description: string
  fun: (farm: Farm, args: any) => any

  constructor(name: string, description: string, cheatFunction: (farm: Farm, args: any) => any) {
    this.name = name
    this.description = description
    this.fun = cheatFunction
  }

  activate(farm: Farm) {
    // @ts-ignore
    window[this.name] = (args: any) => { return this.fun(farm, args) }
  }
}
